import { render } from "./MainConfig.vue?vue&type=template&id=28ca31ac"
import script from "./MainConfig.vue?vue&type=script&lang=js"
export * from "./MainConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__